import React, { useState } from 'react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="bg-gray-100 shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 text-xl font-bold text-gray-800">ISPU</div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 mx-auto">
            <a href="#about" className="text-gray-700 hover:text-green-600">
              About
            </a>
            <a href="#entrepreneurs" className="text-gray-700 hover:text-green-600">
              Entrepreneurs
            </a>
            <a href="#partner" className="text-gray-700 hover:text-green-600">
              Partner
            </a>
            <a href="#impact" className="text-gray-700 hover:text-green-600">
              Impact
            </a>
            <a href="#blog" className="text-gray-700 hover:text-green-600">
              Blog
            </a>
          </div>

          {/* Buttons */}
          <div className="hidden md:flex space-x-4">
            <button className="px-4 py-2 border border-green-600 text-green-600 rounded hover:bg-green-100">
              Donate
            </button>
            <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
              Apply Now
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden">
            <button onClick={toggleMenu}>
              {menuOpen ? (
                <XIcon className="h-6 w-6 text-gray-800" />
              ) : (
                <MenuIcon className="h-6 w-6 text-gray-800" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden px-4 pb-4">
          <div className="flex flex-col space-y-2 text-gray-700">
            <a href="#about">About</a>
            <a href="#entrepreneurs">Entrepreneurs</a>
            <a href="#partner">Partner</a>
            <a href="#impact">Impact</a>
            <a href="#blog">Blog</a>
            <button className="mt-4 px-4 py-2 border border-green-600 text-green-600 rounded hover:bg-green-100">
              Donate
            </button>
            <button className="mt-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
              Apply Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};
